<script lang="ts">
  import type { EmployeeCalendarIntegrationRow } from "./_logic/types"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import { clearOverlays } from "@kontextwerk/web-sdk/core/overlay/globalStores"
  import { mdiSync } from "@mdi/js"
  import { spaNavigate } from "../../../../../../../../../../../../_shared/_logic/navigation"
  const {
    row,
    onSync,
  }: {
    row: EmployeeCalendarIntegrationRow
    onSync: (row: EmployeeCalendarIntegrationRow) => Promise<void>
  } = $props()
  let syncing = $state(false)
  const openTarget = (): void => {
    if (row.actionUrl) {
      clearOverlays()
      spaNavigate(row.actionUrl, { noSearchParam: false })
    }
  }
  const sync = async (): Promise<void> => {
    if (!row.canSync || syncing) return

    syncing = true
    try {
      await onSync(row)
    } finally {
      syncing = false
    }
  }
</script>

<ActionBox
  label={row.employeeLabel}
  tag={row.statusLabel}
  tagColor={row.statusColor}
  tagTooltipContent={row.statusTooltip}
  darkMode={false}
>
  <div class="employee-calendar-integration">
    <p>{row.description}</p>
    {#if row.showConnectionDetails}
      <dl>
        <div><dt>Provider:</dt><dd>{row.providerLabel}</dd></div>
        {#if row.accountEmail}<div><dt>Konto:</dt><dd>{row.accountEmail}</dd></div>{/if}
        <div><dt>Zielkalender:</dt><dd>{row.targetCalendarLabel}</dd></div>
        <div><dt>Berücksichtigte Kalender:</dt><dd>{row.readSourcesLabel}</dd></div>
        <div><dt>Zuletzt erfolgreich gelesen:</dt><dd>{row.lastSyncLabel}</dd></div>
      </dl>
    {/if}
  </div>
  {#snippet buttonSnippet()}<div class="employee-calendar-integration__actions">
      <CTA
        type={row.statusTone === "success" ? "secondaryButton" : "primaryButton"}
        content={row.actionLabel}
        disabled={!row.actionUrl}
        darkMode={true}
        onClick={openTarget}>{#snippet iconSnippet()}<Icon path={row.providerIcon} />{/snippet}</CTA
      >
      {#if row.canSync}<CTA
          type="primaryButton"
          content={syncing ? "Abgleich startet …" : "Jetzt abgleichen"}
          disabled={syncing}
          darkMode={true}
          onClick={() => void sync()}>{#snippet iconSnippet()}<Icon path={mdiSync} />{/snippet}</CTA
        >{/if}
    </div>{/snippet}
</ActionBox>

<style lang="less">
  .employee-calendar-integration {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    color: var(--text-100);
  }
  p,
  dl {
    margin: 0;
  }
  dl {
    display: grid;
    gap: 0.45rem;
  }
  dl div {
    display: flex;
    gap: 0.55rem;
    flex-wrap: wrap;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin: 0;
    opacity: 0.78;
  }
  .employee-calendar-integration__actions {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.6rem;
  }
</style>
